import { createSlice } from "@reduxjs/toolkit";

const stateSlice = createSlice({
  name: "buyer/state",
  initialState: {
    deleteConfirmation: false,
    openDialog: false,
    selectedBuyer: {},
  },
  reducers: {
    toggleDeleteConfirmation: (state, action) => {
      state.deleteConfirmation = action.payload;
    },
    toggleNewDialog: (state, action) => {
      state.openDialog = action.payload;
    },
    setSelectedBuyer: (state, action) => {
      state.selectedBuyer = action.payload;
    },
  },
});

export const { toggleDeleteConfirmation, toggleNewDialog, setSelectedBuyer } =
  stateSlice.actions;

export default stateSlice.reducer;
